import { useMemo } from "react";
// Components
import useTranslate from "hooks/useTranslate";
import Timer from "../Timer";
import WelcomeBonusCardItem from "../../molecules/WelcomeBonusCardItem";

// Hooks

// Types
import { BonusListType } from "../../../types/Bonus";

import "./styles.sass";

type BonusCardBackProps = {
  bonus: BonusListType;
};

const DescriptionSpin = (props: BonusCardBackProps) => {
  // eslint-disable-next-line react/destructuring-assignment
  const { bonus } = props;

  const t = useTranslate();

  const gameName = "game" in bonus && bonus.game && `"${bonus.game.name}"`;
  // eslint-disable-next-line quotes
  const nameGame = gameName && gameName.toString().replaceAll('"', "");
  const currentWager = "wager" in bonus && bonus.wager;

  const expiredDate = useMemo(() => {
    if ("expireDate" in bonus) {
      return bonus.expireDate;
    }
    if ("expireAt" in bonus) {
      return bonus.expireAt;
    }
    return "";
  }, [bonus]);

  const BONUS_LIST_SPIN = [
    { id: 100, name: "bonus.back.game", value: `${nameGame}` },
    {
      id: 101,
      name: "bonus.back.spins",
      value: `${"leftSpins" in bonus && bonus.leftSpins} FS`,
    },
    { id: 102, name: "bonus.back.category.spins", value: "Slots" },
    { id: 103, name: "bonus.back.wager", value: "x50" },
    { id: 104, name: "bonus.back.amount.slots", value: `${currentWager}` },
  ];

  return (
    <div className="DescriptionSpin">
      <div className="DescriptionSpin-block">
        <span className="DescriptionSpin-block__title">
          {t("bonus.info.valid")}
        </span>
        <Timer finishDate={expiredDate} isBonus />
      </div>
      <div className="DescriptionSpin__list">
        {BONUS_LIST_SPIN.map((item) => (
          <WelcomeBonusCardItem key={item.id} bonus={item} />
        ))}
      </div>
    </div>
  );
};

export default DescriptionSpin;
